import { sellingCountryOrNull } from "@/constants/billingCatalog"

export function readLandingCountry(search) {
  const params = typeof search === "string" ? new URLSearchParams(search) : search
  const raw = params?.get?.("country")
  return sellingCountryOrNull(raw)
}
